import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'container',
  'text',
  'promoBanner',
  'aviosShape',
])

export const FlightAviosOnlyBanner = helpers.defineMultiStyleConfig({
  baseStyle: {
    aviosOnlyBanner: {
      isolation: 'isolate',
      height: { base: 225, md: 356 },
      marginTop: { base: '2rem', lg: '4rem' },
      marginBottom: { base: '3.5rem', lg: '4.5rem' },
      position: 'relative',
      backgroundSize: 'cover',
      borderRadius: '2xl',
      overflow: 'hidden',
      backgroundPosition: { base: 'left 10% center', md: 'right center' },
    },
    aviosShape: {
      position: 'relative',
      zIndex: 1,
      height: '100%',
      left: { base: '-55%', md: '-15%', lg: '-10%' },

      svg: {
        height: '100%',
      },
    },
    content: {
      zIndex: 1,
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      alignContent: 'center',
      marginLeft: { base: '0.25rem', md: 'unset' },
    },
    promoTitle: {
      textAlign: { base: 'unset', md: 'center' },
    },
    promoTextWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
    },
    mainText: {
      width: { base: '100%', md: '80%' },
      svg: {
        width: { base: '10rem', md: '20rem' },
      },
    },
    arrowContainer: {
      position: 'relative',
      left: { base: '1rem', md: '3rem' },

      svg: {
        height: '10rem',
        width: { base: '3.5rem', md: '6rem' },
      },
    },
    contentSoldOut: {
      position: 'relative',
      zIndex: 1,
    },
    bgImage: {
      position: 'absolute',
      right: { base: '-10%', md: 0 },
      top: 0,
      bottom: 0,
      left: '30%',
      backgroundSize: 'cover',
      backgroundPosition: 'right center',
    },
    promoBanner: {
      width: { base: '60%', md: '50%', lg: '40%' },
      top: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'absolute',
      zIndex: 5,
    },
    textContainer: {
      maxWidth: { base: '19rem', md: '100%' },
      minWidth: { base: '15rem', md: '100%' },
    },
    backgroundImage: {
      backgroundSize: 'cover',
    },
    introText: {
      fontSize: { base: '1rem', md: '2.2rem' },
      fontWeight: 'bold',
      color: '#82bf04',
    },
    titleText: {
      fontSize: { base: '1rem', md: '2rem' },
      fontWeight: 'medium',
    },
    disclaimerText: {
      position: 'absolute',
      left: { base: '0.5rem', md: '1rem' },
      bottom: { base: '0.5rem', md: '1rem' },
      fontSize: 'sm',
      color: '#FFF',
      zIndex: 10,
    },
    soldOutRibbon: {
      boxShadow: '0 0 6px rgba(0, 0, 0, 0.6)',
      bottom: { base: '15%', md: '20%' },
      borderRadius: '50rem',
      lineHeight: { base: '1.2rem', md: '2.5rem' },
      width: { base: '150%', md: '120%' },
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      flexWrap: 'nowrap',
      position: 'absolute',
      left: { base: '-15%', md: '-10%' },
      gap: { base: '1rem', md: '2rem' },
      zIndex: 1000,
      transform: 'rotate(-5deg)',
      backgroundColor: 'brand.primaryTeal',
      overflow: 'hidden',
      wordWrap: 'nowrap',
    },
    soldOutRibbonText: {
      wordWrap: 'nowrap',
      color: '#FFF',
      fontWeight: 'bold',
      fontSize: { base: '0.7rem', md: 'unset' },
    },
  },
})
